// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRangeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  VALUE_TYPES: {
    none: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_NONE');
      }
    },
    value: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_VALUE');
      },
      dataStructure: {
        name: '',
        key: '',
        text: '',
        canDelete: true
      }
    },
    rangeValue: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_VALUE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    },
    rangePercent: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_PERCENTAGE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    }
  },
  BOOLEAN_OPTION: {
    options: [
      {
        value: 'true',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_TRUE');
        }
      },
      {
        value: 'false',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_FALSE');
        }
      }
    ],
    blankOption: true
  },
  CONSTRAINTS: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('ROLE_SETUP_CONSTANT_CONSTRAINTS_REQUIRE_VALUE');
      }
    }
  },
  MESSAGE: {
    M02: {
      get DUPLICATE_NAME() {
        return localizer.getText('SETTINGS_MESSAGE_NAME_HAS_BEEN_DEFINED');
      },
      get VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_COLOR_HAS_BEEN_DEFINED');
      },
      get RANGE_VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_RANGE_COLOR_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return localizer.getText('SETTINGS_MESSAGE_PERCENT_COLOR_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return localizer.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    },
    M03: {
      get VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_RANGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return localizer.getText('SETTINGS_MESSAGE_PERCENT_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return localizer.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    }
  },
  DATA_TYPE: {
    TEXT: 'Text',
    BOOLEAN: 'Boolean',
    NUMERIC: 'Numeric',
    DATETIME: 'Datetime',
    TIME: 'Time',
    MONEY: 'Money'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SettingsByRangeConstants.js